$(document).ready(function () {
//     /*================================
//      =            Quantity            =
//      ================================*/
//
//     $('.qtyplus').click(function (e) {
//         e.preventDefault();
//
//         var fieldName = $(this).data('field');
//         var className = $(this).data('span');
//
//         var currentVal = parseInt($('input[name="' + fieldName + '"]').val());
//         var maxVal = parseInt($('input[name="' + fieldName + '"]').attr("max"));
//         var newval = currentVal;
//
//         if (!isNaN(currentVal)) {
//             if (!isNaN(maxVal) && currentVal < maxVal) {
//                 newval = currentVal + 1;     //if max value exist and we are lower of it
//             } else if (!isNaN(maxVal) && currentVal == maxVal) {
//                 newval = currentVal;  //if max value exist and we are upper of it
//             } else {
//                 newval = currentVal + 1; // Else increment without max value
//             }
//         } else {
//             newval = 0; // Otherwise put a 0 there
//         }
//
//         // Actions
//         $('input[name="' + fieldName + '"]').val(newval);
//         $('.' + className).text(newval);
//     });
//
// // This button will decrement the value till 0
//     $('.qtyminus').click(function (e) {
//         e.preventDefault();
//
//         var fieldName = $(this).data('field');
//         var className = $(this).data('span');
//
//         var currentVal = parseInt($('input[name="' + fieldName + '"]').val());
//         var minVal = parseInt($('input[name="' + fieldName + '"]').attr("min"));
//         var newval = currentVal;
//
//         if (!isNaN(currentVal) && currentVal > 0) {
//             newval = currentVal - 1; // Decrement one
//         } else {
//             newval = 0; // Otherwise put a 0 there
//         }
//
//         if (!isNaN(minVal) && newval < minVal)
//             newval = minVal;
//
//         // Actions
//         $('input[name="' + fieldName + '"]').val(newval);
//         $('.' + className).text(newval);
//     });


    // Action sur la page panier
    if ($(".cartform").length) {
        $(".cartform").on('change', function () {
            $(this).submit();
        });
    }
});
